import { render, staticRenderFns } from "./Biography.vue?vue&type=template&id=6717ccb0"
import script from "./Biography.vue?vue&type=script&lang=js"
export * from "./Biography.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports